import { render, staticRenderFns } from "./FileBrowserContextMenu.vue?vue&type=template&id=cff9fcaa&scoped=true"
import script from "./FileBrowserContextMenu.vue?vue&type=script&lang=js"
export * from "./FileBrowserContextMenu.vue?vue&type=script&lang=js"
import style0 from "./FileBrowserContextMenu.vue?vue&type=style&index=0&id=cff9fcaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff9fcaa",
  null
  
)

export default component.exports